import React from "react";
import { ReactController } from "../react_controller";
import { LeadScanGrid } from "../../components/grids/LeadScanGrid";

export class LeadScanGridController extends ReactController {
  connect() {
    this.root.render(<LeadScanGrid {...this.propsValue} />);
  }
}
